import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Address } from 'clicklease-ui-elements';
import {
    BusinessInformationState,
    BusinessInformation,
    WritableBusinessInformation,
} from './../../interfaces';
import { BusinessInfoFeatureName } from './business-information.reducer';

const getBusinessInformationState = (
    state: BusinessInformationState
): BusinessInformationState => state;

const getBusinessInformation = ({
    data,
}: BusinessInformationState): BusinessInformation => data;

const getBusinessWritableInformation = ({
    data,
}: BusinessInformationState): WritableBusinessInformation => ({
    address: data.address,
    name: data.name,
    phone: data.phone,
    email: data.email,
});

const getIsLoaded = ({ isLoaded }: BusinessInformationState): boolean =>
    isLoaded;

const getBusinessInformationId = ({ data }: BusinessInformationState): string =>
    data.businessKey;

const getBusinessInformationName = ({
    data,
}: BusinessInformationState): string => data.name;

const getBusinessInformationPhone = ({
    data,
}: BusinessInformationState): string => data.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

const getBusinessInformationEmail = ({
    data,
}: BusinessInformationState): string => data.email;

const getBusinessInformationAddress = ({
    data,
}: BusinessInformationState): Address => data.address;

const getBusinessInformationAddressLine1 = ({
    data,
}: BusinessInformationState): string =>
    `${data.address.street},`;

const getBusinessInformationAddressLine2 = ({
    data,
}: BusinessInformationState): string =>
    `${data.address.city}, ${data.address.state} ${data.address.zipcode}`;

export const BusinessInformationFeatureSelector =
    createFeatureSelector<BusinessInformationState>(BusinessInfoFeatureName);

export const BusinessInformationStateSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationState
);

export const BusinessInformationSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformation
);

export const BusinessWritableInformationSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessWritableInformation
);

export const BusinessInformationIsLoadedSelector = createSelector(
    BusinessInformationFeatureSelector,
    getIsLoaded
);

export const BusinessInformationIdSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationId
);

export const BusinessInformationNameSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationName
);

export const BusinessInformationPhoneSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationPhone
);

export const BusinessInformationEmailSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationEmail
);

export const BusinessInformationAddressSelector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationAddress
);

export const BusinessInformationAddressLine1Selector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationAddressLine1
);

export const BusinessInformationAddressLine2Selector = createSelector(
    BusinessInformationFeatureSelector,
    getBusinessInformationAddressLine2
);
